import { render } from "./LNavComponent.vue?vue&type=template&id=78227685&scoped=true"
import script from "./LNavComponent.vue?vue&type=script&lang=js"
export * from "./LNavComponent.vue?vue&type=script&lang=js"

import "./LNavComponent.vue?vue&type=style&index=0&id=78227685&scoped=true&lang=css"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78227685"]])

export default __exports__